import { render } from "./ZenPublicationsTypes.vue?vue&type=template&id=1a73d9dd"
import script from "./ZenPublicationsTypes.vue?vue&type=script&lang=js"
export * from "./ZenPublicationsTypes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__